export default __webpack_public_path__ + "static/plexus-desktop-1-mobile-b38adcde560c9cc6c43231067bab999f.webp";